import React from 'react'

import Stack from '@mui/material/Stack'

import { P, Text } from '@mxenabled/mxui'
import { ChevronRight } from '@mxenabled/mx-icons'

import { useGlobalCopyStore } from '../../common'
import type { CardStatus } from '../../common/constants/FinStrong'

import { KeyIndicatorsTabItemType } from '../constants'

import KeyIndicatorsTabItemDrawer from './KeyIndicatorsTabItemDrawer'
import StatusChip from './StatusChip'

interface KeyIndicatorsTabsItemProps {
  drawerFor: KeyIndicatorsTabItemType
  title: string
  description: string
  cardState: keyof typeof CardStatus
}

const KeyIndicatorsTabsItem: React.FC<KeyIndicatorsTabsItemProps> = ({
  drawerFor,
  title,
  description,
  cardState = 'MISSING',
}) => {
  const { finstrong: copyContent } = useGlobalCopyStore()

  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false)

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      setIsDrawerOpen(true)
    }
  }

  return (
    <>
      <Stack
        aria-label={`${copyContent.key_indicators_open} ${title}`}
        onClick={() => setIsDrawerOpen(true)}
        onKeyDown={handleKeyDown}
        role="button"
        sx={{
          alignItems: 'center',
          borderRadius: 2,
          cursor: 'pointer',
          flexDirection: 'row',
          gap: 12,
          justifyContent: 'space-between',
          outline: '1px solid',
          outlineColor: 'divider',
          p: 16,
        }}
        tabIndex={0}
      >
        <Stack sx={{ gap: 8, minWidth: 0 }}>
          <Stack sx={{ alignItems: 'center', flexDirection: 'row', gap: 8 }}>
            <Text sx={{ fontWeight: 600 }} variant="body1">
              {title}
            </Text>
            <StatusChip status={cardState} />
          </Stack>
          <P color="secondary" variant="subtitle2">
            {description}
          </P>
        </Stack>
        <ChevronRight color="secondary" size={24} />
      </Stack>
      <KeyIndicatorsTabItemDrawer
        drawerFor={drawerFor}
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </>
  )
}

export default KeyIndicatorsTabsItem
